var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcSoundOffSmall = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.514 7.97 5.767 6.224a.75.75 0 0 1 1.06-1.06l13.031 13.03a.75.75 0 1 1-1.06 1.06l-2.427-2.425v1.977a.75.75 0 0 1-1.191.606l-4.554-3.318H7.884a2.38 2.38 0 0 1-2.379-2.379v-3.393a2.38 2.38 0 0 1 2.01-2.35m7.357 7.358v2.002l-3.559-2.593a.75.75 0 0 0-.441-.144H7.884a.88.88 0 0 1-.879-.879v-3.393c0-.485.394-.879.88-.879h1.1zm-2.575-8.603 1.048 1.093 1.527-1.113v2.708l1.5 1.565V5.23a.75.75 0 0 0-1.191-.606z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSoundOffSmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };